import CitySEOHead from "@/components/feature/CitySEOHead";
import BoyntonBeachHeroSection from "./components/HeroSection";
import BoyntonBeachStickyNav from "./components/StickyNav";
import BoyntonBeachProcessingTimeSection from "./components/ProcessingTimeSection";
import BoyntonBeachServicesSection from "./components/ServicesSection";
import BoyntonBeachLocalAreaSection from "./components/LocalAreaSection";
import BoyntonBeachTravelTimingSection from "./components/TravelTimingSection";
import BoyntonBeachDestinationsSection from "./components/DestinationsSection";
import BoyntonBeachTestimonialsSection from "./components/TestimonialsSection";
import BoyntonBeachAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import BoyntonBeachComparisonSection from "./components/ComparisonSection";
import BoyntonBeachMistakesSection from "./components/MistakesSection";
import BoyntonBeachHowItWorksSection from "./components/HowItWorksSection";
import BoyntonBeachFAQSection, { faqs } from "./components/FAQSection";
import BoyntonBeachHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import BoyntonBeachFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const pageTitle = "Emergency Passport Boynton Beach, FL — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Emergency and expedited passport services in Boynton Beach, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving southern Palm Beach County travelers.";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function BoyntonBeachPage() {
  return (
    <>
      <CitySEOHead
        city="Boynton Beach"
        state="Florida"
        stateAbbr="FL"
        route="/boynton-beach"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Boynton Beach, Florida"
        geoPosition="26.5318;-80.0905"
        keywords="expedited passport Boynton Beach, emergency passport Boynton Beach FL, same day passport Boynton Beach, fast passport Florida, passport renewal Boynton Beach, Palm Beach County passport"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Florida"
        statePageRoute="/states/florida"
        lastModified="2026-06-09"
        serviceAreaDesc="Fast Passport Center does not have a physical office in Boynton Beach — we serve this area remotely. Emergency and expedited passport services as fast as 24 hours for Boynton Beach and southern Palm Beach County travelers."
      />

      <div className="font-sans">
      <BoyntonBeachHeroSection />
      <BoyntonBeachStickyNav />
      <BoyntonBeachProcessingTimeSection />
      <BoyntonBeachServicesSection />
      <BoyntonBeachLocalAreaSection />
      <BoyntonBeachTravelTimingSection />
      <BoyntonBeachDestinationsSection />
      <BoyntonBeachTestimonialsSection />
      <BoyntonBeachAcceptanceFacilitiesSection />
      <BoyntonBeachComparisonSection />
      <BoyntonBeachMistakesSection />
      <BoyntonBeachHowItWorksSection />
      <BoyntonBeachFAQSection />
      <BoyntonBeachHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/boynton-beach" state="FL" />
      <BoyntonBeachFinalCTA />
      </div>
    </>
  );
}